var convertImages = function() {
  var images = document.getElementsByTagName('img')

  for (let image of images) {
    if (!image.classList.contains('lazy')) {
      image.classList.add('lazy')
    }
    if (!image.getAttribute('data-src')) {
      image.setAttribute('data-src', image.getAttribute('src'))
    }
  }
}

//initialize yall.js for deferring images
document.addEventListener('DOMContentLoaded', convertImages)
document.addEventListener('DOMContentLoaded', () => yall)